module.exports = __webpack_public_path__ + "media/components/utils/fonts/Gotham-Light-9cea7310cefbca07371888c2d948c14e.otf";